import React from "react";
import "./cta.css";

const Cta = (props) => {
  return (
    <div className="cta-container">
      <div className="cta-textContainer">
        <p className="cta-subtitle">{props.subtitle}</p>
        <p className="cta-title">{props.title}</p>
      </div>
      <a href={props.btnLink} className="cta-btn">
        {props.btnText}
      </a>
    </div>
  );
};

export default Cta;
